export enum Product {
    UNDEFINED = "default",
    USER_APP = "user_app",
    RESTAURANT = "restaurant",
    DRIVER = "driver",
    KITCHEN = "kitchen",
    ADMIN = "admin",
    LADING_PAGE = "landing_page"
}
